<template>
  <div>
    <template v-if="!loading">
      <b-row align-v="center">
        <b-col lg="4">
          <b-row align-v="center">
            <b-col cols="8" lg="12">
              <h6 class="h6-semibold-azure-uppercase">{{ current.pad(2) }}</h6>
              <h3 class="h3-semibold-black">La tua Casa</h3>
            </b-col>

            <b-col cols="4" lg="12" v-if="isMobile" class="mb-4">
              <div class="icon">
                <img src="img/icone/SGR-Icons-casa.svg">
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="4">
          <b-form-group
              label="Quanto è grande la tua casa?"
              label-for="field1"
              :state="states.mq"
          >
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <div class="input-group-text">mq</div>
              </div>
              <b-form-input id="field1" v-model="localOptions.casa.mq" @input="setValid($event,'mq')"
                            placeholder="Es: 120" type="number" required
                            class="form-control-gray-900"></b-form-input>
            </div>
          </b-form-group>

          <b-form-group
              label="L’edificio è di proprietà?"
              label-for="field2"
              :state="states.diProprieta"
          >
            <b-form-select id="field2" v-model="localOptions.casa.diProprieta" :options="siNo"
                           @input="setValid($event,'diProprieta')"
                           class="form-control form-control-gray-900"></b-form-select>
          </b-form-group>

          <b-form-group
              label="Che tipo di edificio è?"
              label-for="field3"
              :state="states.type"
          >
            <b-form-select id="field3" v-model="localOptions.casa.type" :options="tipoEdificio"
                           @input="setValid($event,'type')" class="form-control form-control-gray-900"></b-form-select>
          </b-form-group>

          <b-form-group
              label="Anno di costruzione"
              label-for="field4"
              :state="states.anno"
          >
            <b-form-select id="field4" v-model="localOptions.casa.anno" :options="annoCostruzione"
                           @input="setValid($event,'anno')" class="form-control form-control-gray-900"></b-form-select>
          </b-form-group>

          <b-form-group
              label="Numero di persone che vi abitano"
              label-for="field5"
              :state="states.persone"
          >
            <b-form-input id="field5" v-model="localOptions.casa.persone" @input="setValid($event,'persone')"
                          placeholder="Es: 2" type="number" required
                          class="form-control-gray-900"></b-form-input>
          </b-form-group>

          <b-form-group
              label="Hai effettuato interventi di efficientamento energetico negli ultimi 10 anni?"
              label-for="field6"
              :state="states.interventi"
          >
            <b-form-select id="field6" v-model="localOptions.casa.interventi" :options="siNo"
                           @input="setValid($event,'interventi')"
                           class="form-control form-control-gray-900"></b-form-select>
          </b-form-group>

        </b-col>
        <b-col lg="3" offset-lg="1" class=" text-center lg:text-right">
          <div class="icon" v-if="!isMobile">
            <img src="img/icone/SGR-Icons-casa.svg">
          </div>
          <button @click="nextStep" class="button-azure-rounded mt-2 lg:mt-8 px-8">Avanti</button>
        </b-col>
      </b-row>
    </template>
  </div>

</template>

<script>

export default {
  name: 'Step-1',
  data() {
    return {
      thisStep: 1,
      localOptions: null,
      siNo: [{text: 'Seleziona un valore', value: ''}, {text: 'Sì', value: true}, {text: 'No', value: false}],
      tipoEdificio: [
        {text: 'Tipologia edificio', value: ''},
        {
          text: 'Casa/Villa unifamiliare',
          value: 'Casa/Villa unifamiliare'
        },
        {
          text: 'Casa/Villa plurifamiliare o a schiera',
          value: 'Casa/Villa plurifamiliare o a schiera'
        },
        {
          text: 'Condominio fino a 8 appartamenti',
          value: 'Condominio fino a 8 appartamenti'
        },
        {text: 'Condominio con oltre 8 appartamenti', value: 'Condominio con oltre 8 appartamenti'}
      ],
      annoCostruzione: [
        {text: 'Anno costruzione', value: ''},
        {
          text: 'Prima del 1950',
          value: 'Prima del 1950'
        }, {
          text: 'Dal 1951 al 1975',
          value: 'Dal 1951 al 1975'
        }, {
          text: 'Dal 1976 al 2005',
          value: 'Dal 1976 al 2005'
        }, {text: 'Dopo il 2005', value: 'Dopo il 2005'}],
      loading: true,
      states: {},
    }
  },
  props: {
    steps: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      default: 1,
    },
    options: {
      type: [Array, Object],
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  created() {
    this.$emit('setCurrent', this.thisStep)
    this.localOptions = {...this.options};
    this.loading = false;

    if(typeof this.$analytics != 'undefined') {
      this.trackFbViewContent('check-up-energetico', 'step-1');
    }
  },
  methods: {
    nextStep() {
      let that = this;
      let valid = true;
      that.states = {};
      for (const [key, value] of Object.entries(that.localOptions.casa)) {
        if (value === null || value === '') {
          that.states[key] = true;
          valid = false;
        }
      }
      if (valid) this.$emit('nextStep', this.thisStep + 1, this.localOptions)
    },
    setValid(value, key) {
      this.states[key] = value === null || value === '';
    }
  },
}
</script>

<style scoped lang="scss">
</style>